import React from 'react';


export const ErrorContext = React.createContext({error: null, modalError: null, setError: null, unsetError: null});